/**
 * @desc Yung-获取审批业务key
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.ApprovalBeforeRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/approval/getBusinessKey`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
